import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Text } from '@bonusly/design-system';

import { ValidationError } from '../../lib/validation';
import { useErrorText } from './hooks/use-error-text';

export const MultipleErrors: FC<{ errors: ValidationError[] }> = ({ errors }) => {
	const { t } = useTranslation('action_input');
	const e = useErrorText();

	return (
		<>
			<Text>{t('validation.many_issues')}</Text>
			<Box as="ol" pl={5}>
				{errors.map((error, i) => {
					return (
						<Box as="li" key={i}>
							{e(error)}
						</Box>
					);
				})}
			</Box>
		</>
	);
};
